import React from 'react';
import { Alert, Anchor, GridContainer, GridItem, H3 } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import HotlineInfoSection from '../HotlineInfoSection';
import PhoneNumberSection from '../PhoneNumberSection';

const FormFooter: React.FC = () => {
  const { t } = useTranslation();

  const myZooplusLinkUrl = t('common.my_account_url');
  const hotlineInfoEnding = t('footer.hotline.info_ending');

  return (
    <div className="hotlineSection contactForm__container" data-test="hotlineSection.container">
      <header className="pp-mb-l footer__header">
        <H3>{t('footer.hotline.header')}</H3>
      </header>

      <Alert closeButtonAriaLabel="Notification title">
        {t('footer.hotline.info')}
        <Anchor
          href={myZooplusLinkUrl}
          variant="primary"
          target="_blank"
          className={hotlineInfoEnding ? '' : 'pp-pl-2xs'}>
          "{t('common.my_account')}"
        </Anchor>
        {hotlineInfoEnding || '.'}
      </Alert>

      <div className="hotlineSection__body">
        <GridContainer>
          <GridItem
            colStart={{ default: 1, md: 1 }}
            colSpan={{ default: 6, md: 6 }}
            data-test="contactForm.footer.hotlineSection.schedule">
            <HotlineInfoSection />
          </GridItem>
          <GridItem colStart={{ default: 1, md: 7 }} colSpan={{ default: 6, md: 6 }}>
            <PhoneNumberSection />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};
export default FormFooter;
